
export const AppImage = () => {
    return (
        <h4 style={{textAlign: 'center'}}>
            <img alt="Crane and Turtle"
                className="app_image"
                src="ct.png" />
        </h4>
    )
}